module.exports = __webpack_public_path__ + "img/tigo_star.21d24757.png";